import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSearchParams, useNavigate } from "react-router-dom";
import Form from "@src/components/forms/Form";
import AppUtils from "@src/utils/appUtils";
import { signolImagesRepositoryURL } from "@src/constants/constants";
import { Button, FormInput, ImageWithRetry } from "@src/components/atoms";
import ResetPasswordForm from "../../components/forms/ResetPasswordForm";

const envType = import.meta.env.VITE_REACT_APP_ENV;

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const navigateTo = useNavigate();
  const [completed, setCompleted] = useState(false);

  const token = searchParams.get("token");

  // Redirect to login if no token
  useEffect(() => {
    if (!token || token === "undefined") {
      navigateTo("/");
    }
  }, [token, navigateTo]);

  if (!token) {
    return null; // Will redirect in useEffect
  }

  if (completed) {
    return (
      <div className="bg-white rounded-2xl mx-8 overflow-clip w-full max-w-md xl:max-w-lg">
        <div className="mx-auto py-6 px-8 bg-white">
          <div className="mx-auto py-8 w-40">
            <ImageWithRetry
              src={`${signolImagesRepositoryURL}/SignolLogoPrimary.png`}
              alt="Signol logo"
            />
            {envType !== "production" && (
              <span className="relative bottom-3 float-right font-bold text-pink-400">
                {envType === "dev" ? "qa" : envType}
              </span>
            )}
          </div>
          <div className="text-center space-y-4">
            <h2 className="text-2xl font-bold text-green-600 mb-4">Success!</h2>
            <p className="text-sm text-gray-700 mb-6">
              Your Signol app password has been reset successfully. You will now
              be redirected to the login page.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <ResetPasswordForm
      token={token}
      onSuccess={() => {
        setCompleted(true);
        // Redirect after 3 seconds
        setTimeout(() => {
          window.location.href = "/";
        }, 3000);
      }}
    />
  );
};

export const resetPasswordPageControls = {};

ResetPasswordPage.propTypes = AppUtils.getPropTypeFromControls(
  resetPasswordPageControls,
);

export default ResetPasswordPage;
